import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Observable } from "rxjs";

export abstract class DialogService {
	abstract openRoute(routeName: string, dialogConfig?: any): Observable<MatDialogRef<any>> | undefined;
}
